import { FunctionComponent } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { createPortal } from "react-dom";

const GridContentSpinner: FunctionComponent = () => {
  const { promiseInProgress } = usePromiseTracker();
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );

  const gridContent = document && document.querySelector(".k-grid-content");
  return promiseInProgress
    ? gridContent
      ? createPortal(loadingPanel, gridContent)
      : loadingPanel
    : null;
};

export default GridContentSpinner;
